<img *ngIf="_photoInfo?.file && hasImagePreview && previewImageUrl" [src]="previewImageUrl | secure | async"
     class="products-img">
<img *ngIf="_photoInfo?.file && hasImagePreview && !previewImageUrl" [src]="backend.concat(imagePath, _photoInfo?.file._id) | secure | async"
     class="products-img">
<div *ngIf="_photoInfo?.file && !hasImagePreview" class="no-img-placeholder" title="No image">
  <font-awesome [cssClass]="'no-img-icon'" [icon]="'fa-regular fa-file'" role="img"></font-awesome>
  <span class="no-img-text">No img</span>
</div>

<span (click)="clickFile()" [ngClass]="{'mw-130px': isMobile}" class="file-text btn-cursor text-truncate">
  {{ _photoInfo?.file?.filename }}
</span>
<font-awesome
  (click)="delete($event)"
  *ngIf="_photoInfo?.file && _deletable &&
         (roles.cdReviewer.includes(_initInfo.userType) ||
         (roles.cdCreator.includes(_initInfo.userType) && (!_initInfo.lastRejectedAt || _initInfo.lastRejectedAt < _photoInfo?.file?.createdAt)))"
  [cssClass]="'ml-12px'"
  [icon]="'fa-regular fa-xmark'" role="button"></font-awesome>

<div (click)="imgFileInput.click()" *ngIf="!_photoInfo?.file"
     class="item-file btn-cursor">
  <input disabled hidden name="filename" placeholder="Select a File">
  <input #imgFileInput (change)="fileSelected($event)" accept="image/*" hidden type="file"/>
  <font-awesome [cssClass]="'icon-21px'" [icon]="'fa-light fa-image'" id="select-icon" role="button"></font-awesome>
</div>

<button (click)="clickFile()"
        *ngIf="_photoInfo?.file && _photoInfo?.comment"
        class="btn photo-btn align-items-center">
  <i class="fa-light fa-comment-dots icon-21px"></i>
</button>
